<template>
  <div :class="[`group-273-9`, className || ``]">
    <div class="rectangle-95-22"></div>
  </div>
</template>

<script>
export default {
  name: "Group273",
  props: ["className"],
};
</script>

<style>
.group-273-9 {
  background-color: var(--alto);
  border-radius: 2px;
  display: flex;
  height: 8px;
  left: 25px;
  position: absolute;
  top: 307px;
  width: 484px;
}

.rectangle-95-22 {
  background-color: var(--azure-radiance);
  border-radius: 2px;
  height: 8px;
  width: 374px;
}

.group-273-9.group-273-11 {
  background-color: var(--alto);
  border-radius: 2px;
  display: flex;
  height: 8px;
  left: 25px;
  position: absolute;
  top: 415px;
  width: 484px;
}
</style>
